export enum ChurnZeroAttributeNamesEnum {
  CfHsScheduledJobBuyingCenter = 'cf_HsScheduledJobBuyingCenter',
  CfHsScheduledJobCompany = 'cf_HsScheduledJobCompany',
  CfHsScheduledJobContact = 'cf_HsScheduledJobContact',
  CfHsScheduledJobFiltersBuyingCenter = 'cf_HsScheduledJobFiltersBuyingCenter',
  CfHsScheduledJobFiltersCompany = 'cf_HsScheduledJobFiltersCompany',
  CfHsScheduledJobFiltersContact = 'cf_HsScheduledJobFiltersContact',
  CfHsScheduledJobJobChangeSetting = 'cf_HsScheduledJobJobChangeSetting',
  CfHsScheduledJobTechnoCompany = 'cf_HsScheduledJobTechnoCompany',
  CfHsScheduledJobTechnoContact = 'cf_HsScheduledJobTechnoContact',
  CfHsTriggeredJobBuyingCenter = 'cf_HsTriggeredJobBuyingCenter',
  CfHsTriggeredJobCompany = 'cf_HsTriggeredJobCompany',
  CfHsTriggeredJobContact = 'cf_HsTriggeredJobContact',
  CfHsTriggeredJobTechnoCompany = 'cf_HsTriggeredJobTechnoCompany',
  CfHsTriggeredJobTechnoContact = 'cf_HsTriggeredJobTechnoContact',
}
